export default __webpack_public_path__ + "static/media/web-3.912b0af0.webp";